import { customerDocumentTypeMessages } from '@common/intl'
import { TicketDocumentType } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const ticketDocumentTypeMessages = defineMessages({
  issueProof: {
    defaultMessage: 'Issue proof',
    description: 'ticket document type title',
  },
  outstandingDebtProof: {
    defaultMessage: 'Outstanding debt proof',
    description: 'ticket document type title',
  },
  paymentAvailabilityProof: {
    defaultMessage: 'Payment availability proof',
    description: 'ticket document type title',
  },
})

export function translateTicketDocumentType(
  intl: IntlShape,
  type: TicketDocumentType,
  otherType: string | null,
): string {
  switch (type) {
    case TicketDocumentType.ISSUE_PROOF:
      return intl.formatMessage(ticketDocumentTypeMessages.issueProof)
    case TicketDocumentType.OTHER:
      if (otherType) {
        return intl.formatMessage(customerDocumentTypeMessages.otherWithOtherType, { otherType })
      } else {
        return intl.formatMessage(customerDocumentTypeMessages.other)
      }

    case TicketDocumentType.OUTSTANDING_DEBT_PROOF:
      return intl.formatMessage(ticketDocumentTypeMessages.outstandingDebtProof)
    case TicketDocumentType.PAYMENT_AVAILABILITY_PROOF:
      return intl.formatMessage(ticketDocumentTypeMessages.paymentAvailabilityProof)
  }
}
